"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.optimizeTextureImage = void 0;
var _createCanvas = require("./createCanvas");
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
/**
 * Creates a new canvas with the given minimum size if the image size is smaller
 * This makes the mipmap quality better eg. when the image is close to the next power of two size
 * (like 2000x2000 -> 2048x2048)
 * @param {HTMLImageElement|HTMLCanvasElement} image
 * @param {number} maxTextureSize
 * @param {number} minTextureSize
 * @return {HTMLImageElement|HTMLCanvasElement}
 */
var optimizeTextureImage = exports.optimizeTextureImage = function optimizeTextureImage(image) {
  var maxTextureSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2048;
  var minTextureSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2048;
  var textureSize = Math.max(image.width, image.height);
  if (textureSize <= maxTextureSize && textureSize >= minTextureSize) {
    return image;
  }
  if (textureSize > maxTextureSize) {
    textureSize = maxTextureSize;
  } else if (textureSize < minTextureSize) {
    textureSize = minTextureSize;
  }
  var width = image.width,
    height = image.height;
  var ratio = width / height;
  if (ratio > 1) {
    width = textureSize;
    height = width / ratio;
  } else {
    height = textureSize;
    width = height * ratio;
  }

  // eslint-disable-next-line no-console
  console.log("Optimizing texture image for better mipmaps:", "".concat(image.width, "x").concat(image.height, " -> ").concat(width, "x").concat(height));
  var _createWorkingCanvas = (0, _createCanvas.createWorkingCanvas)({
      width: width,
      height: height
    }),
    _createWorkingCanvas2 = _slicedToArray(_createWorkingCanvas, 2),
    canvas = _createWorkingCanvas2[0],
    ctx = _createWorkingCanvas2[1];
  ctx.drawImage(image, 0, 0, width, height);
  return canvas;
};